// 云平台续费
const Recharge = () => import('../../pages/recharge/recharge/recharge.vue')
const RechargeMobileByBranch = () => import('../../pages/recharge/rechargeMobile/rechargeMobileByBranch.vue')
const RechargeMobile = () => import('../../pages/recharge/rechargeMobile/rechargeMobile.vue')
const RechargeMobileBuyHistory = () => import('../../pages/recharge/rechargeMobile/buyHistory.vue')
const RechargeMobileBuyHistoryNew = () => import('../../pages/recharge/rechargeMobile/buyHistoryNew/index.vue')
const CloudRenewAdv = () => import('../../pages/recharge/cloudRenewAdv/cloudRenewAdv.vue')
const cloudRenewAdvMobile = () => import('../../pages/recharge/cloudRenewAdv/cloudRenewAdvMobile.vue')
const AfterSales = () => import('../../pages/recharge/afterSales/afterSales.vue')
const AfterSalesSubmitSuccess = () => import('../../pages/recharge/afterSales/afterSalesSubmitSuccess.vue')
const router = [
  {
    path: '/recharge/recharge/:token/:sisscloudtokenid?/:otherData?',
    component: Recharge,
    name: 'Recharge',
    meta: {
      title: '服务续费'
    },
    props(route) {
      return {
        token: route.params.token,
        sisscloudtokenid: route.params.sisscloudtokenid,
        otherData: route.params.otherData
      }
    }
  },
  {
    path: '/rechargeMobile/rechargeMobile/:token/:sisscloudtokenid?/:otherData?',
    component: RechargeMobile,
    name: 'RechargeMobile',
    meta: {
      title: '服务购买'
    },
    props(route) {
      return {
        token: route.params.token,
        sisscloudtokenid: route.params.sisscloudtokenid,
        otherData: route.params.otherData
      }
    }
  },
  {
    path: '/rechargeMobile/buyHistory/:token/:sisscloudtokenid?/:otherData?',
    component: RechargeMobileBuyHistory,
    name: 'RechargeMobileBuyHistory',
    meta: {
      title: '购买记录'
    },
    props(route) {
      return {
        token: route.params.token,
        sisscloudtokenid: route.params.sisscloudtokenid,
        otherData: route.params.otherData
      }
    }
  },
  {
    path: '/rechargeMobile/rechargeMobileByBranch/:token/:sisscloudtokenid?/:otherData?',
    component: RechargeMobileByBranch,
    name: 'RechargeMobileByBranch',
    meta: {
      title: '服务购买'
    },
    props(route) {
      return {
        token: route.params.token,
        sisscloudtokenid: route.params.sisscloudtokenid,
        otherData: route.params.otherData
      }
    }
  },
  {
    path: '/cloudRenewAdv/cloudRenewAdv/:token/:sisscloudtokenid?/:otherData?',
    component: CloudRenewAdv,
    name: 'CloudRenewAdv',
    meta: {
      title: '云平台使用费'
    },
    props(route) {
      return {
        token: route.params.token,
        sisscloudtokenid: route.params.sisscloudtokenid,
        otherData: route.params.otherData
      }
    }
  },
  {
    path: '/cloudRenewAdvMobile/cloudRenewAdvMobile/:token/:sisscloudtokenid?/:otherData?',
    component: cloudRenewAdvMobile,
    name: 'cloudRenewAdvMobile',
    meta: {
      title: '云平台使用费-移动端'
    },
    props(route) {
      return {
        token: route.params.token,
        sisscloudtokenid: route.params.sisscloudtokenid,
        otherData: route.params.otherData
      }
    }
  },
  {
    path: '/rechargeMobile/buyHistoryNew/:token/:sisscloudtokenid?/:otherData?',
    component: RechargeMobileBuyHistoryNew,
    name: 'RechargeMobileBuyHistoryNew',
    meta: {
      title: '购买记录'
    },
    props(route) {
      return {
        token: route.params.token,
        sisscloudtokenid: route.params.sisscloudtokenid,
        otherData: route.params.otherData
      }
    }
  },
  {
    path: '/recharge/afterSales/:token/:sisscloudtokenid?/:otherData?',
    component: AfterSales,
    name: 'AfterSales',
    meta: {
      title: '售后'
    },
    props(route) {
      return {
        token: route.params.token,
        sisscloudtokenid: route.params.sisscloudtokenid,
        otherData: route.params.otherData
      }
    }
  },
  {
    path: '/recharge/afterSalesSubmitSuccess/:token/:sisscloudtokenid?/:otherData?',
    component: AfterSalesSubmitSuccess,
    name: 'AfterSalesSubmitSuccess',
    meta: {
      title: '售后提交成功'
    },
    props(route) {
      return {
        token: route.params.token,
        sisscloudtokenid: route.params.sisscloudtokenid,
        otherData: route.params.otherData
      }
    }
  }
]
export default router
